var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkinNoHair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 16.2622C0.888034 16.2622 1 16.1503 1 16.0122C1 15.8742 0.888164 15.7622 0.75 15.7622V15.2622C0.335824 15.2622 0 15.5979 0 16.0122C0 16.4263 0.335694 16.7622 0.75 16.7622V16.2622Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 15.2622C1.16418 15.2622 1.5 15.5979 1.5 16.0122C1.5 16.4263 1.16431 16.7622 0.75 16.7622V16.2622C0.611966 16.2622 0.5 16.1503 0.5 16.0122C0.5 15.8742 0.611836 15.7622 0.75 15.7622V15.2622Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 16.2622C12.388 16.2622 12.5 16.1502 12.5 16.0122C12.5 15.8742 12.3882 15.7622 12.25 15.7622V15.2622C11.8358 15.2622 11.5 15.598 11.5 16.0122C11.5 16.4262 11.8356 16.7622 12.25 16.7622V16.2622Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 15.2622C12.6642 15.2622 13 15.598 13 16.0122C13 16.4262 12.6644 16.7622 12.25 16.7622V16.2622C12.112 16.2622 12 16.1502 12 16.0122C12 15.8742 12.1118 15.7622 12.25 15.7622V15.2622Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 16.2622C12.388 16.2622 12.5 16.1502 12.5 16.0122C12.5 15.8742 12.3882 15.7622 12.25 15.7622V15.2622C11.8358 15.2622 11.5 15.598 11.5 16.0122C11.5 16.4262 11.8356 16.7622 12.25 16.7622V16.2622Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 15.2622C12.6642 15.2622 13 15.598 13 16.0122C13 16.4262 12.6644 16.7622 12.25 16.7622V16.2622C12.112 16.2622 12 16.1502 12 16.0122C12 15.8742 12.1118 15.7622 12.25 15.7622V15.2622Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 22.7183C0.888034 22.7183 1 22.6063 1 22.4683C1 22.3302 0.888034 22.2183 0.75 22.2183V21.7183C0.335824 21.7183 0 22.054 0 22.4683C0 22.8825 0.335824 23.2183 0.75 23.2183V22.7183Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 21.7183C1.16418 21.7183 1.5 22.054 1.5 22.4683C1.5 22.8825 1.16418 23.2183 0.75 23.2183V22.7183C0.611966 22.7183 0.5 22.6063 0.5 22.4683C0.5 22.3302 0.611966 22.2183 0.75 22.2183V21.7183Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 22.7183C6.88803 22.7183 7 22.6063 7 22.4683C7 22.3302 6.88803 22.2183 6.75 22.2183V21.7183C6.33583 21.7183 6 22.054 6 22.4683C6 22.8825 6.33583 23.2183 6.75 23.2183V22.7183Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 21.7183C7.16417 21.7183 7.5 22.054 7.5 22.4683C7.5 22.8825 7.16417 23.2183 6.75 23.2183V22.7183C6.61197 22.7183 6.5 22.6063 6.5 22.4683C6.5 22.3302 6.61197 22.2183 6.75 22.2183V21.7183Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 22.7183C14.888 22.7183 15 22.6063 15 22.4683C15 22.3302 14.888 22.2183 14.75 22.2183V21.7183C14.3358 21.7183 14 22.054 14 22.4683C14 22.8825 14.3358 23.2183 14.75 23.2183V22.7183Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 21.7183C15.1642 21.7183 15.5 22.054 15.5 22.4683C15.5 22.8825 15.1642 23.2183 14.75 23.2183V22.7183C14.612 22.7183 14.5 22.6063 14.5 22.4683C14.5 22.3302 14.612 22.2183 14.75 22.2183V21.7183Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 22.7183C20.888 22.7183 21 22.6063 21 22.4683C21 22.3302 20.888 22.2183 20.75 22.2183V21.7183C20.3358 21.7183 20 22.054 20 22.4683C20 22.8825 20.3358 23.2183 20.75 23.2183V22.7183Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 21.7183C21.1642 21.7183 21.5 22.054 21.5 22.4683C21.5 22.8825 21.1642 23.2183 20.75 23.2183V22.7183C20.612 22.7183 20.5 22.6063 20.5 22.4683C20.5 22.3302 20.612 22.2183 20.75 22.2183V21.7183Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 19.2422C3.38816 19.2422 3.5 19.1302 3.5 18.9922C3.5 18.8541 3.38803 18.7422 3.25 18.7422V18.2422C2.8357 18.2422 2.5 18.5781 2.5 18.9922C2.5 19.4065 2.83583 19.7422 3.25 19.7422V19.2422Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 18.2422C3.6643 18.2422 4 18.5781 4 18.9922C4 19.4065 3.66417 19.7422 3.25 19.7422V19.2422C3.11184 19.2422 3 19.1302 3 18.9922C3 18.8541 3.11197 18.7422 3.25 18.7422V18.2422Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 19.2422C9.38816 19.2422 9.5 19.1302 9.5 18.9922C9.5 18.8541 9.38803 18.7422 9.25 18.7422V18.2422C8.8357 18.2422 8.5 18.5781 8.5 18.9922C8.5 19.4065 8.83583 19.7422 9.25 19.7422V19.2422Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 18.2422C9.6643 18.2422 10 18.5781 10 18.9922C10 19.4065 9.66417 19.7422 9.25 19.7422V19.2422C9.11184 19.2422 9 19.1302 9 18.9922C9 18.8541 9.11197 18.7422 9.25 18.7422V18.2422Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 19.2422C9.38816 19.2422 9.5 19.1302 9.5 18.9922C9.5 18.8541 9.38803 18.7422 9.25 18.7422V18.2422C8.8357 18.2422 8.5 18.5781 8.5 18.9922C8.5 19.4065 8.83583 19.7422 9.25 19.7422V19.2422Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 18.2422C9.6643 18.2422 10 18.5781 10 18.9922C10 19.4065 9.66417 19.7422 9.25 19.7422V19.2422C9.11184 19.2422 9 19.1302 9 18.9922C9 18.8541 9.11197 18.7422 9.25 18.7422V18.2422Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 19.2422C17.3882 19.2422 17.5 19.1302 17.5 18.9922C17.5 18.8541 17.388 18.7422 17.25 18.7422V18.2422C16.8356 18.2422 16.5 18.5782 16.5 18.9922C16.5 19.4064 16.8358 19.7422 17.25 19.7422V19.2422Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18.2422C17.6644 18.2422 18 18.5782 18 18.9922C18 19.4064 17.6642 19.7422 17.25 19.7422V19.2422C17.1118 19.2422 17 19.1302 17 18.9922C17 18.8541 17.112 18.7422 17.25 18.7422V18.2422Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 19.2422C23.3882 19.2422 23.5 19.1302 23.5 18.9922C23.5 18.8541 23.388 18.7422 23.25 18.7422V18.2422C22.8356 18.2422 22.5 18.5782 22.5 18.9922C22.5 19.4064 22.8358 19.7422 23.25 19.7422V19.2422Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 18.2422C23.6644 18.2422 24 18.5782 24 18.9922C24 19.4064 23.6642 19.7422 23.25 19.7422V19.2422C23.1118 19.2422 23 19.1302 23 18.9922C23 18.8541 23.112 18.7422 23.25 18.7422V18.2422Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.5C0.223858 12.5 0 12.7239 0 13C0 13.2761 0.223858 13.5 0.5 13.5H2.30232C2.8072 15.5898 4.58266 16.6454 6.3107 16.6525C8.0408 16.6596 9.78824 15.6135 10.2143 13.5H13.8023C14.3072 15.5898 16.0827 16.6454 17.8107 16.6525C19.5408 16.6596 21.2882 15.6135 21.7143 13.5H23.5C23.7761 13.5 24 13.2761 24 13C24 12.7239 23.7761 12.5 23.5 12.5H21.626C21.1943 12.5 20.8245 12.8087 20.7473 13.2334C20.4523 14.8561 19.1615 15.658 17.8148 15.6525C16.4637 15.647 15.123 14.8263 14.76 13.2036C14.6693 12.7981 14.3084 12.5 13.8844 12.5H10.126C9.69433 12.5 9.32445 12.8087 9.24726 13.2334C8.9523 14.8561 7.6615 15.658 6.31481 15.6525C4.96366 15.647 3.62304 14.8263 3.26004 13.2036C3.16932 12.7981 2.80841 12.5 2.38443 12.5H0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinNoHair);
export default __webpack_public_path__ + "static/media/skin-no-hair.ec92570887349cb62029b9ceabdaebb8.svg";
export { ForwardRef as ReactComponent };